export type ProfileBaseInfo = {
  id: string;
  name: string;
  email: string;
  exp: number;
  exists_notifications: boolean;
  email_notification: boolean;
  tg_notification: boolean;
  notification_total: number;
}

export type Profile<Role = UserRoles.ADMIN | UserRoles.DEALER> = ProfileBaseInfo & (
  Role extends UserRoles.ADMIN ? {
    role: UserRoles.ADMIN;
  } : {
    role: UserRoles.DEALER;
    lead_limit: number;
    total_lead: number;
  }
)

export enum UserRoles {
  ADMIN = 'admin',
  DEALER = 'dealer',
}

export type AuthDTO = {
  email: string;
  password: string;
}

export type ChangeSettingsDTO = {
  email: string;
  password: string;
  newPassword: string;
  newPassword2: string;
}